import { phoneService } from '../_services';

const state = {
  all: {
    data: {},
    loading: {},
    updating:{},
    deleting:{},
    error:{},
  },
  update: {},
  current: {
    data: {},
    loading: {},
    updating:{},
    deleting:{},
    error:{},
  },

};


const actions = {


  update({ dispatch, commit }, phone) {
    commit('updateRequest');

    phoneService.update(phone)
      .then(
        phones => {
                    dispatch('alert/success', 'Registro actualizado', { root: true }),
                    commit('updateSuccess', phones),
                    commit('users/updatePhoneSuccess', phones, { root: true })
                  },
        error => {
                    dispatch('alert/error', {text: 'Se ha producido un error', data: error}, { root: true }),
                    commit('updateFailure', error)
                  }
      );
  },
  create({ dispatch, commit }, phone) {
    commit('createRequest');

    phoneService.create(phone)
      .then(
        phones => {
          dispatch('alert/success', 'Registro creado', { root: true }),
            commit('createSuccess', phones),
            commit('users/createPhoneSuccess', phones, { root: true })
        },
        error => {
          dispatch('alert/error', {text: 'Se ha producido un error', data: error}, { root: true }),
            commit('createFailure', error)
        }
      );
  },

  deletePhone({ dispatch, commit }, id) {
    commit('deleteRequest');

    phoneService.delete(id)
      .then(
        phone => {
          dispatch('alert/success', 'Registro eliminado', { root: true }),
            commit('deleteSuccess', phone),
            commit('users/deletePhoneSuccess', id, { root: true })
        },
        error => {
          dispatch('alert/error', {text: 'Se ha producido un error', data: error}, { root: true }),
            commit('deleteFailure', error)
        }
      );
  },


};

const mutations = {

  /*
  CREATE
   */
  createRequest(state) {
    state.current.updating = true;
  },
  createSuccess(state, phone) {
    state.current.updating = false;
  },
  createFailure(state, error) {
    state.current.updating = false;
    state.current.error = error.data;
  },

  updateRequest(state) {
    state.current.updating = true;
  },
  updateSuccess(state, phone) {
    state.current.updating = false;
  },
  updateFailure(state, error) {
    state.current.updating = false;
    state.current.error = error.data;
  },

  deleteRequest(state) {
    state.current.deleting = true;
  },
  deleteSuccess(state, phone) {
    state.current.deleting = false;
  },
  deleteFailure(state, error) {
    state.current.deleting = false;
    state.current.error = error.data;
  },

};

export const phones = {
  namespaced: true,
  state,
  actions,
  mutations
};
